import { forEach } from "lodash";

import setGroupingWithNotifications from "./setGroupingWithNotifications";

export default (groupings, columns) => {
  forEach(groupings, (grouping) => {
    setGroupingWithNotifications(grouping, columns);
  });

  if (groupings[0].isRoot) {
    forEach(columns, (column, index) => {
      column.notification = groupings[0].notifications[index].notification;
    });
  }
};
